import { Sparkles } from "lucide-react";

// Feature: Legal Baseline — short AI disclosure shown wherever AI suggestions/drafts appear.
export function AiDisclosure({ className = "" }) {
  return (
    <p className={`flex items-start gap-1.5 text-xs text-[#94A3B8] ${className}`} data-testid="ai-disclosure">
      <Sparkles size={13} className="mt-0.5 shrink-0" />
      <span>AI-generated suggestion — you review and confirm before it's used. Output may be incomplete or inaccurate, makes no legal conclusions, and is never sent anywhere automatically.</span>
    </p>
  );
}
